import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faTrash } from '@fortawesome/free-solid-svg-icons';
import UIMultiCalendar from "components/UI/MultiCalendar/MultiCalendar";
import './CartSelectItem.scss';

const CartSelectItem = ({showSingleItem, showPricePart, idx, item, cartObjects,
    formatMessage, onDateAction, onDelete
}) => {
    const [userInputs, setUserInputs] = useState({});
    
    const initData = () => {
        if (item.showdates && item.showdates.length) {
            const { itemsShowsObj } = cartObjects;
            let initObj = {};
            item.showdates.forEach((date, idx) => {
                if (itemsShowsObj[item.id] && itemsShowsObj[item.id][date]) {
                    initObj[date] = itemsShowsObj[item.id][date];
                } else initObj[date] = 1;
            });
            setUserInputs(initObj);
        }
    }

    useEffect(() => {
        initData();
    }, []);

    useEffect(() => {
        initData();
    }, [cartObjects.itemsDateObj[item.id]]);

    const onCalendarClick = () => { }
    const onBtnChooseClick = () => { }
    const onBtnOkClick = () => { }

    const showCalendar = () => {
        return (
            <div className="listitem-item listitem-action">
                <UIMultiCalendar formatMessage={formatMessage} onBtnChooseClick={onBtnChooseClick}
                    btnOkId="calendar.done" btnChooseId="calendar.choose"
                    onDateAction={onDateAction} item={item} cartObjects={cartObjects}
                    onBtnOkClick={onBtnOkClick} onCalendarClick={onCalendarClick} />
            </div>
        )
    }

    return (
        <div className="cartselectitem-grid">
            <div>{`${idx+1}.`}</div>
            <div key={`itemslist${item.id}_${idx}`}
                className="cartselectitem-itemslist-li">
                {showSingleItem({ item, idx })}
            </div>
            <div>{showCalendar({item})}</div>
            <div>{showPricePart({item, idx})}</div>
            <div className="cartselectitem-action" onClick={()=>onDelete()}>
              <FontAwesomeIcon icon={faTrash} />
            </div>
        </div>
    )
}

export default CartSelectItem;